import React, { useEffect, useState } from 'react';
import DownArrow from '@material-ui/icons/ExpandMore';
import { Button } from '@material-ui/core';

function DropdownActions(props) {
    const {opts=[], label, styleClassName} = props;
    const [showDrop, setShowDrop] = useState(false)
    const {onChangeAction, actionDisabled, deviceStatus} = props;

    useEffect(()=>{
      window.onclick = function(event) {
        if (!event.target.matches('.dropbtn')) {
          var dropdowns = document.getElementsByClassName("dropdown-content");
          var i;
          for (i = 0; i < dropdowns.length; i++) {
            var openDropdown = dropdowns[i];
            if (openDropdown.classList.contains('show')) {
              openDropdown.classList.remove('show');
            }
          }
        }
      }
    })

    function myFunction() {
        document.getElementById(`actionDropdown ${label}`).classList.toggle("show");
        // setShowDrop(true)
    }

    function dropOptClick(value, name) {
      onChangeAction(value, name)
    }   

    return (
      <div className={`dropdown ${styleClassName}`}>
        <button onClick={myFunction} disabled={actionDisabled} style={{marginBottom:'0px',backgroundColor:"#0073E6" , fontSize:"0.9rem", borderRadius:"4px" ,height:"36px"}} className="dropbtn" >{label}<DownArrow className="no-point-events" fontSize='small' /> </button>            
          <div id={`actionDropdown ${label}`} className="dropdown-content">
              {opts.map(val => 
                <button disabled={val.active} onClick={()=>dropOptClick(val.value, val.name)}>{val.name}</button> 
              )}
          </div>          
      </div>
    )
}
export default DropdownActions;